import { Dispatch } from 'redux';
import { change } from 'redux-form';
import { CHECKOUT_FORM_NAME, TICKETS_PAGE_FORM_NAME } from '../constants';
import { PaymentMethodType } from '../models/paymentMethods/enums';
import { CheckoutState } from '../state';

const APPLE_PAY_NONCE_NAME = 'payment.applePayBraintreeNonce';
const PAYPAL_NONCE_NAME = 'payment.paypalBraintreeNonce';
const GOOGLEPAY_NONCE_NAME = 'payment.googlePayBraintreeNonce';

export const getPaymentMethodAndNonceFromPaymentData = (payment: {
    applePayBraintreeNonce?: string;
    paypalBraintreeNonce?: string;
    googlePayBraintreeNonce?: string;
}) => {
    if (payment.applePayBraintreeNonce) {
        return {
            nonce: APPLE_PAY_NONCE_NAME,
            paymentMethod: PaymentMethodType.APPLE_PAY,
        };
    }

    if (payment.paypalBraintreeNonce) {
        return {
            nonce: PAYPAL_NONCE_NAME,
            paymentMethod: PaymentMethodType.NONCE_BRAINTREE,
        };
    }

    if (payment.googlePayBraintreeNonce) {
        return {
            nonce: GOOGLEPAY_NONCE_NAME,
            paymentMethod: PaymentMethodType.GOOGLE_PAY,
        };
    }

    return null;
};

export const clearNonceInForm = (dispatch: Dispatch<CheckoutState>) => {
    const formsWithNonceFields = [CHECKOUT_FORM_NAME, TICKETS_PAGE_FORM_NAME];
    const nonceFields = [
        APPLE_PAY_NONCE_NAME,
        PAYPAL_NONCE_NAME,
        GOOGLEPAY_NONCE_NAME,
    ];
    for (const formName of formsWithNonceFields) {
        for (const fieldName of nonceFields) {
            dispatch(change(formName, fieldName, null));
        }
    }
};
